import { QRCodeSVG } from "qrcode.react";
import { AuthPageLayout } from "./AuthPageLayout";
import { LoadingButton } from "./LoadingButton";
import { CodeInputField } from "./CodeInputField";

/**
 * TOTP セットアップ UI
 * テナントが MFA 必須の場合、初回ログイン後に表示される
 */
export const TOTPSetupUI: React.FC<{
  totpUri: string;
  secretKey: string;
  verifyCode: string;
  loading: boolean;
  error: string | null;
  recoverySuggestion: string | null;
  onVerifyCodeChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}> = ({
  totpUri,
  secretKey,
  verifyCode,
  loading,
  error,
  recoverySuggestion,
  onVerifyCodeChange,
  onSubmit,
  onCancel,
}) => {
  return (
    <AuthPageLayout>
      {/* タイトル */}
      <h2 className="text-3xl font-bold text-center text-neutral-900 mb-4">
        二段階認証の設定
      </h2>
      <p className="text-center text-neutral-600 mb-8">
        認証アプリ（Google Authenticator等）で
        <br />
        下記のQRコードをスキャンしてください。
      </p>

      {/* QRコード */}
      <div className="flex justify-center mb-6">
        <div className="p-4 bg-white border border-neutral-200 rounded-2xl">
          <QRCodeSVG value={totpUri} size={200} />
        </div>
      </div>

      {/* シークレットキー（手動入力用） */}
      <div className="mb-8">
        <p className="text-sm text-neutral-500 text-center mb-2">
          QRコードを読み取れない場合は、以下のキーを手動で入力してください。
        </p>
        <div className="bg-neutral-50 border border-neutral-200 rounded-xl p-3 text-center">
          <code className="text-sm font-mono text-neutral-800 break-all select-all">
            {secretKey}
          </code>
        </div>
      </div>

      {/* フォーム */}
      <form onSubmit={onSubmit} className="space-y-6">
        {/* 認証コード入力 */}
        <div>
          <label className="block text-sm font-medium text-neutral-700 mb-2">
            認証アプリに表示されている6桁のコードを入力
          </label>
          <CodeInputField
            value={verifyCode}
            onChange={onVerifyCodeChange}
            disabled={loading}
            placeholder="000000"
          />
        </div>

        {/* エラーメッセージ */}
        {error && <div className="text-sm text-red-600">{error}</div>}
        {recoverySuggestion && (
          <div className="text-sm text-neutral-700">{recoverySuggestion}</div>
        )}

        {/* ボタン */}
        <div className="space-y-3">
          <LoadingButton loading={loading} loadingMessage="設定中..." label="設定を完了する" />

          <button
            type="button"
            onClick={onCancel}
            className="w-full bg-gray-500 hover:bg-gray-600 text-white py-4 rounded-2xl text-xl font-bold transition-colors"
            disabled={loading}
          >
            キャンセル
          </button>
        </div>
      </form>
    </AuthPageLayout>
  );
};
